export function useExtractPage(ref: string) {
    const match = ref?.match(/\/page\/(.+)/)
    return match && match[1] && match[1]
}
